import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementBinTypeComponent } from './case-management-bin-type.component';

const routes: Routes = [{ path: '', component: CaseManagementBinTypeComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementBinTypeRoutingModule { }
